import React from "react";
import styles from "./index.css";

const IconNotification = () => <span className={styles.notification}>1</span>;

export default IconNotification;



// WEBPACK FOOTER //
// ./template/components/IconNotification/index.js